import React, { useState, useEffect } from "react";
import { useSelector, useDispatch } from "react-redux";
import {
  fetchAuctionBidHistoryData,
  fetchAuctionBidHistoryDataSuccess,
  fetchSearchDropDownForAuctionBidHistory,
  fetchAuctionBidHistoryDataApiCall,
  fetchAuctionBidHistoryLotWiseData,
  fetchAuctionBidHistoryLotWiseDataSuccess,
  fetchAuctionBidHistoryLotWiseDataApiCall,
} from "../../store/actions";
import { ThreeDots } from "react-loader-spinner";
import moment from "moment";
import { Tooltip } from "@mui/material";
import Modals from "../../components/common/Modal";
import Base64ToExcelDownload from "../Base64ToExcelDownload";
import { uploadedFileDownload } from "../uploadDocument/UploadedFileDownload";

let tempData =
  window.location.pathname &&
  window.location.pathname.split("/") &&
  window.location.pathname.split("/")[4];
let auctionCenterId = tempData && atob(tempData);

let sessionTypeData = [
  { lotKey: "Normal", lotValue: 1 },
  { lotKey: "PRS", lotValue: 2 },
];

let generalType = 0;
function AuctionBidHistoryReportPage() {
  const dispatch = useDispatch();

  const [sessionTime, setSessionTime] = useState("");
  const [sessionType, setSessionType] = useState("");
  const [auctioneerId, setAuctioneerId] = useState("");
  const [lotNumber, setLotNumber] = useState("");
  const [loader, setLoader] = useState(false);
  const [viewModal, setViewModal] = useState(false);
  const [viewLotNumber, setViewLotNumber] = useState("");

  useEffect(() => {
    // setLoader(true);
    dispatch(fetchAuctionBidHistoryDataSuccess([]));

    let paylod = {
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
      auctioneerId: "",
      sessionType: "",
      sessionTime: "",
      lotNo: "",
      isExport: 0,
      exportType: "",
      userType: !(
        atob(localStorage.getItem("argument6")) == "TAOUSER" ||
        atob(localStorage.getItem("argument6")) == "TEABOARDUSER" ||
        atob(localStorage.getItem("argument6")) == "SUPERADMIN"
      )
        ? 1
        : 2,
      userId: atob(sessionStorage.getItem("argument2")),
    };
    dispatch(fetchSearchDropDownForAuctionBidHistory(paylod));

    let payloadDataForDefault = {
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
      auctioneerId: "",
      sessionType: "",
      sessionTime: "",
      lotNo: "",
      isExport: 0,
      exportType: "",
      userType: !(
        atob(localStorage.getItem("argument6")) == "TAOUSER" ||
        atob(localStorage.getItem("argument6")) == "TEABOARDUSER" ||
        atob(localStorage.getItem("argument6")) == "SUPERADMIN"
      )
        ? 1
        : 2,
      userId: atob(sessionStorage.getItem("argument2")),
    };

    dispatch(fetchAuctionBidHistoryData(payloadDataForDefault));
  }, []);

  let fetchAuctionBidHistoryDataResponse = useSelector(
    (state) =>
      state.auctionBidHistoryReportReducer?.fetchAuctionBidHistoryDataReducer
        ?.responseData
  );

  let fetchAuctionBidHistoryDataExportResponse = useSelector(
    (state) =>
      state.auctionBidHistoryReportReducer
        .fetchAuctionBidHistoryDataReducerExport?.responseData
  );

  const fetchSessionTimeForAuctionBidHistoryResponse = useSelector(
    (state) =>
      state.auctionBidHistoryReportReducer
        ?.fetchSearchDropDownForAuctionBidHistory?.responseData?.[0]
  );

  const fetchLotNumberForAuctionBidHistoryResponse = useSelector(
    (state) =>
      state.auctionBidHistoryReportReducer
        ?.fetchSearchDropDownForAuctionBidHistory?.responseData?.[1]
  );

  const fetchAuctioneerForAuctionBidHistoryResponse = useSelector(
    (state) =>
      state.auctionBidHistoryReportReducer
        ?.fetchSearchDropDownForAuctionBidHistory?.responseData?.[2]
  );

  let fetchAuctionBidHistoryLotWiseDataResponse = useSelector(
    (state) =>
      state.auctionBidHistoryReportReducer
        ?.fetchAuctionBidHistoryLotWiseDataReducer?.responseData
  );

  let fetchAuctionBidHistoryLotWiseDataApiCallResponse = useSelector(
    (state) =>
      state.auctionBidHistoryReportReducer
        .fetchAuctionBidHistoryLotWiseDataReducerApiCall
  );

  const handleSearch = (type) => {
    // setLoader(true);
    generalType = type;
    let payloadDataForDefault = {
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
      auctioneerId: auctioneerId,
      sessionType: sessionType,
      sessionTime: sessionTime,
      lotNo: lotNumber,
      isExport: type,
      exportType: 1 == type ? "excel" : 2 == type ? "pdf" : "",
      userType: !(
        atob(localStorage.getItem("argument6")) == "TAOUSER" ||
        atob(localStorage.getItem("argument6")) == "TEABOARDUSER" ||
        atob(localStorage.getItem("argument6")) == "SUPERADMIN"
      )
        ? 1
        : 2,
      userId: atob(sessionStorage.getItem("argument2")),
    };
    dispatch(fetchAuctionBidHistoryData(payloadDataForDefault));
  };

  const clearSearch = () => {
    setSessionTime("");
    setLotNumber("");
    setAuctioneerId("");

    let payloadDataForDefault = {
      auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
      auctioneerId: "",
      sessionType: "",
      sessionTime: "",
      lotNo: "",
      isExport: 0,
      exportType: "",
      userType: !(
        atob(localStorage.getItem("argument6")) == "TAOUSER" ||
        atob(localStorage.getItem("argument6")) == "TEABOARDUSER" ||
        atob(localStorage.getItem("argument6")) == "SUPERADMIN"
      )
        ? 1
        : 2,
      userId: atob(sessionStorage.getItem("argument2")),
    };
    dispatch(fetchAuctionBidHistoryData(payloadDataForDefault));
  };

  const handleViewClick = (lotNumber, flag) => {
    setViewLotNumber(lotNumber);
    setViewModal(flag);
    if (true == flag) {
      let payloadDataForDefault = {
        auctionCenterId: auctionCenterId && parseInt(auctionCenterId),
        lotNo: lotNumber,
        userType: !(
          atob(localStorage.getItem("argument6")) == "TAOUSER" ||
          atob(localStorage.getItem("argument6")) == "TEABOARDUSER" ||
          atob(localStorage.getItem("argument6")) == "SUPERADMIN"
        )
          ? 1
          : 2,
        userId: atob(sessionStorage.getItem("argument2")),
      };

      dispatch(fetchAuctionBidHistoryLotWiseData(payloadDataForDefault));
    } else {
      dispatch(fetchAuctionBidHistoryLotWiseDataSuccess([]));
    }
  };

  let fetchAuctionBidHistoryDataApiCallResponse = useSelector(
    (state) =>
      state.auctionBidHistoryReportReducer
        .fetchAuctionBidHistoryDataReducerApiCall
  );

  useEffect(() => {
    if (true == fetchAuctionBidHistoryDataApiCallResponse) {
      dispatch(fetchAuctionBidHistoryDataApiCall(false));
      if (1 == generalType) {
        let exportFileData =
          fetchAuctionBidHistoryDataExportResponse?.exported_file;
        if (exportFileData != null) {
          Base64ToExcelDownload(exportFileData, "BidHistory.xlsx");
        }
      } else if (2 == generalType) {
        let exportFileData =
          fetchAuctionBidHistoryDataExportResponse?.exported_file;
        if (exportFileData != null) {
          uploadedFileDownload(
            exportFileData,
            "BidHistory.pdf",
            `data:application/pdf;base64`
          );
        }
      }
      setLoader(false);
    }

    if (true == fetchAuctionBidHistoryLotWiseDataApiCallResponse) {
      dispatch(fetchAuctionBidHistoryLotWiseDataApiCall(false));
      setLoader(false);
    }
  });
  return (
    <>
      <div className="row">
        <div className="col-lg-12">
          <div className="row align-items-end">
            <div className="col-md-4">
              <div className="FormGroup">
                <label>Session Type</label>
                <select
                  className="form-control select-form"
                  value={sessionType}
                  onChange={(e) => setSessionType(e.target.value)}
                >
                  <option key="" value="">
                    Select Session Type
                  </option>
                  {sessionTypeData?.map((state) => (
                    <option key={state.lotKey} value={state.lotValue}>
                      {state.lotKey}
                    </option>
                  ))}
                </select>
              </div>
            </div>

            <div className="col-md-4">
              <div className="FormGroup">
                <label>Session Time</label>
                <select
                  className="form-control select-form"
                  value={sessionTime}
                  onChange={(e) => setSessionTime(e.target.value)}
                >
                  <option key="" value="">
                    Select Session Time
                  </option>
                  {fetchSessionTimeForAuctionBidHistoryResponse?.map(
                    (state) => (
                      <option key={state.key} value={state.value}>
                        {state.key}
                      </option>
                    )
                  )}
                </select>
              </div>
            </div>

            <div className="col-md-4">
              <div className="FormGroup">
                <label>Lot No</label>
                <select
                  className="form-control select-form"
                  value={lotNumber}
                  onChange={(e) => setLotNumber(e.target.value)}
                >
                  <option value="">Select Lot No</option>
                  {fetchLotNumberForAuctionBidHistoryResponse &&
                    fetchLotNumberForAuctionBidHistoryResponse.map((state) => (
                      <option key={state.key} value={state.value}>
                        {state.key}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="col-md-4">
              <div className="FormGroup">
                <label>Auctioneer</label>
                <select
                  className="form-control select-form"
                  value={auctioneerId}
                  onChange={(e) => setAuctioneerId(e.target.value)}
                >
                  <option value="">Select Auctioneer</option>
                  {fetchAuctioneerForAuctionBidHistoryResponse &&
                    fetchAuctioneerForAuctionBidHistoryResponse.map((state) => (
                      <option key={state.key} value={state.value}>
                        {state.key}
                      </option>
                    ))}
                </select>
              </div>
            </div>

            <div className="col-md-12">
              <div className="BtnGroup">
                <button className="SubmitBtn" onClick={() => handleSearch(0)}>
                  Search
                </button>

                <button className="Clear" onClick={() => clearSearch()}>
                  Clear
                </button>

                <button class="SubmitBtn" onClick={() => handleSearch(1)}>
                  <i class="fa fa-file-excel"></i>
                </button>

                <button class="SubmitBtn" onClick={() => handleSearch(2)}>
                  <i class="fa fa-file-pdf"></i>
                </button>
              </div>
            </div>
          </div>
        </div>
      </div>

      <div className="row">
        <div className="col-lg-12 mt-4">
          {loader ? (
            <div className="">
              <ThreeDots
                visible={true}
                height="80"
                width="80"
                color="#4fa94d"
                radius="9"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : fetchAuctionBidHistoryDataResponse == [] ||
            fetchAuctionBidHistoryDataResponse == undefined ||
            fetchAuctionBidHistoryDataResponse?.length == 0 ? (
            <div className="NoData">No records found</div>
          ) : (
            <table className="table table-bordered">
              <thead>
                <tr>
                  <th>Lot No</th>
                  <th>Mark Code</th>
                  <th>Grade Code</th>
                  <th>Status</th>
                  <th>View</th>
                </tr>
              </thead>
              <tbody>
                {fetchAuctionBidHistoryDataResponse?.map((item, index) => (
                  <tr key={index}>
                    <td>{item.lotNo}</td>
                    <td>{item.markCode}</td>
                    <td>{item.gradeCode}</td>
                    <td>{item.status}</td>
                    <td>
                      <Tooltip title="View" placement="top">
                        <i
                          className="fa fa-eye"
                          onClick={() => handleViewClick(item.lotNo, true)}
                        ></i>
                      </Tooltip>
                    </td>
                  </tr>
                ))}
              </tbody>
            </table>
          )}
        </div>
      </div>

      {viewModal ? (
        <Modals
          title={""}
          show={viewModal}
          handleClose={() => handleViewClick("", false)}
          size="xl"
          centered
        >
          {loader ? (
            <div className="">
              <ThreeDots
                visible={true}
                height="80"
                width="80"
                color="#4fa94d"
                radius="9"
                ariaLabel="three-dots-loading"
                wrapperStyle={{}}
                wrapperClass=""
              />
            </div>
          ) : (
            <div className="row">
              <div className="col-lg-12">
                <table className="table table-striped">
                  <thead>
                    <tr>
                      <th>Lot No</th>
                      <th>Buyer Name</th>
                      <th>Total No. Of Packages</th>
                      <th>Sold Price</th>
                      <th>Status</th>
                      <th>Bid Entry Date And Time</th>
                      <th>Session Time</th>
                    </tr>
                  </thead>
                  <tbody>
                    {fetchAuctionBidHistoryLotWiseDataResponse?.map(
                      (item, index) => (
                        <tr key={index}>
                          <td>{item.lotNo}</td>
                          <td>{item.buyerName}</td>
                          <td>{item.totalNoOfPackages}</td>
                          <td>{item.soldPrice}</td>
                          <td>{item.status}</td>
                          <td>{item.bidEntryDateAndTime}</td>
                          <td>{item.sessionTime}</td>
                        </tr>
                      )
                    )}
                  </tbody>
                </table>
              </div>
            </div>
          )}
        </Modals>
      ) : (
        ""
      )}
    </>
  );
}
export default AuctionBidHistoryReportPage;
